export const FORM_OPTIONAL_MESSAGE_MAX_CHARACTERS = 150
